import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { ContactUsFormComponent } from '../../shared/Components/contact-us-form/contact-us-form.component';

@Component({
  selector: 'app-our-product',
  imports: [SharedModule, ContactUsFormComponent],
  templateUrl: './our-product.component.html',
  styleUrl: './our-product.component.css',
})
export class OurProductComponent {
  activeTab = 0;
  tabs = [
    { title: '01 The Challenge' },
    { title: '02 Solution' },
    { title: '03 Technology Stack' },
    { title: '04 Scope' },
  ];
  ourproduct: any;

  selectTab(index: number) {
    this.activeTab = index;
  }
}
